import { Service, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from 'app/foundation/service/local-storage.service';
import { Location } from '@angular/common';
import { SessionStorageService } from 'app/foundation/service/session-storage.service';
import { Observable, of } from 'rxjs';

export class Credentials {
    constructor(
        public username: string,
        public password: string,
        public rememberMe: boolean,
    ) {}
}

export interface IAuthServerProvider {
    login: (credentials: Credentials) => Observable<object>;
    loginSAML2: (rememberMe: boolean) => Observable<object>;
    loginOIDC: (rememberMe: boolean) => Observable<object>;
    logout: () => Observable<object>;
    clearCaches: () => Observable<undefined>;
}

@Service()
export class AuthServerProvider implements IAuthServerProvider {
    private http = inject(HttpClient);
    private localStorageService = inject(LocalStorageService);
    private sessionStorageService = inject(SessionStorageService);
    private location = inject(Location);

    login(credentials: Credentials): Observable<object> {
        return this.http.post('api/core/public/authenticate', credentials);
    }

    loginSAML2(rememberMe: boolean): Observable<object> {
        return this.http.post('api/core/public/saml2', rememberMe.toString());
    }

    loginOIDC(rememberMe: boolean): Observable<object> {
        const isRememberMeEnabled = rememberMe === true ? 'true' : 'false';
        window.location.href = window.location.origin + this.location.prepareExternalUrl(`/oauth2/authorization/oidc?rememberMe=${isRememberMeEnabled}`);
        return of({});
    }

    logout(): Observable<object> {
        return this.http.post('api/core/public/logout', null);
    }

    /**
     * Clears all the caches, should be invoked during logout
     */
    clearCaches(): Observable<undefined> {
        this.localStorageService.clear();
        this.sessionStorageService.clear();
        // The local or session storage might have to be cleared asynchronously in future due to updated browser apis. This is why this method is already acting asynchronous.
        return of(undefined);
    }
}
